import {commitOutsideView} from './mk-layout-stability.js';
(() => {
  const key = 'mk-interest-session-v1';
  const words = value => String(value || '').toLowerCase().match(/[a-z]{3,24}/g)?.filter(w => !['the','and','for','with','from','your','custom','personalized'].includes(w)).slice(0,12) || [];
  const permitted = () => window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true;
  function history() {
    if (!permitted()) return {views:[],terms:[]};
    try {
      const data = JSON.parse(sessionStorage.getItem(key) || 'null');
      return data && Date.now() - data.time < 7200000 && Array.isArray(data.views) && Array.isArray(data.terms) ? data : {views:[],terms:[]};
    } catch { return {views:[],terms:[]}; }
  }
  function record() {
    if (!permitted()) { try { sessionStorage.removeItem(key); } catch {} return; }
    try {
      const context = JSON.parse(document.getElementById('MKInterestContext')?.textContent || '{}');
      const data = history();
      if (context.product) data.views = [context.product, ...data.views.filter(p => p.id !== context.product.id)].slice(0,6);
      if (context.search) data.terms = [...new Set([...words(context.search), ...data.terms])].slice(0,12);
      data.time = Date.now();
      sessionStorage.setItem(key, JSON.stringify(data));
    } catch {}
  }
  const ready = new Promise(resolve => {
    if (window.Shopify?.customerPrivacy) { record(); resolve(); }
    else if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => { if (!error) record(); resolve(); });
    } else resolve();
  });
  document.addEventListener('visitorConsentCollected', record);
  class MKInterestFeatured extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.controller = new AbortController();
      this.load();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.cancelCommit?.(); this.controller?.abort(); this.started = false; }
    async load() {
      await Promise.race([ready, new Promise(resolve => setTimeout(resolve,1500))]);
      if (!this.isConnected) return;
      const grid = this.querySelector('.mk-interest__grid');
      if (!grid) return;
      const data = history();
      const terms = new Set([...data.terms, ...data.views.slice(0,2).flatMap(v => words(v.words))]);
      const pool = [...grid.querySelectorAll('[data-mk-candidate]')].map(node => ({node,related:false}));
      const seed = data.views[0]?.id || this.dataset.seed;
      if (seed && /^\d+$/.test(String(seed))) {
        try {
          const url = new URL(this.dataset.url, location.origin);
          if (url.origin !== location.origin) throw Error('Invalid recommendations endpoint');
          url.searchParams.set('section_id',this.dataset.section);
          url.searchParams.set('product_id',String(seed));
          url.searchParams.set('limit','10');
          url.searchParams.set('intent','related');
          const response = await fetch(url, {signal:AbortSignal.any([this.controller.signal, AbortSignal.timeout(6000)]),credentials:'same-origin'});
          if (response.ok) {
            const html = new DOMParser().parseFromString(await response.text(),'text/html');
            html.querySelectorAll('mk-interest-featured [data-mk-candidate]').forEach(node => pool.push({node,related:true}));
          }
        } catch {}
      }
      if (!this.isConnected) return;
      const visible = new Set([...document.querySelectorAll('#product-grid a[href*="/products/"]')].map(a => a.pathname.split('/products/')[1]?.split('/')[0]));
      const ranked = new Map();
      for (const item of pool) {
        const {node,related} = item;
        if (visible.has(node.dataset.handle)) continue;
        const score = (related ? 5 : 1) + words(node.dataset.keywords + ' ' + node.dataset.tags).reduce((n,w) => n + (terms.has(w) ? 4 : 0),0);
        const previous = ranked.get(node.dataset.id);
        if (!previous || score > previous.score) ranked.set(node.dataset.id,{node,score});
      }
      const selected = [...ranked.values()].sort((a,b) => b.score - a.score).slice(0,Number(this.dataset.limit) || 4);
      const apply = () => {
        grid.replaceChildren(...selected.map(x => x.node));
        this.hidden = selected.length === 0;
        this.classList.add('is-ready');
      };
      if (this.hidden) apply();
      else this.cancelCommit = commitOutsideView(this, apply);
    }
  }
  if (!customElements.get('mk-interest-featured')) customElements.define('mk-interest-featured',MKInterestFeatured);
})();
